import React from "react";
import "../css/About.css";

const About = () => {
  return (
    <div className="about4">

      {/* ================= HERO ================= */}
      <section className="ab4-hero">
        <div className="ab4-hero-inner">
          <h1>Who We Are</h1>
          <p>
            SHANK is more than a gym — it's a bright, playful space where fitness 
            feels fun, friendly, and empowering.
          </p>
        </div>
      </section>


      {/* ================= STORY SPLIT ================= */}
      <section className="ab4-story">
        <div className="story-left">
          <h2>Our Story</h2>
          <p>
            Born from the idea that movement should spark joy, SHANK blends playful 
            energy with strong training fundamentals. We ditched the cold gym vibes 
            and created something warmer — a space where community matters, progress 
            is celebrated, and workouts feel like fun challenges rather than chores.
          </p>
          <p>
            Every class, trainer, and corner of SHANK is designed to uplift your mind, 
            body, and confidence. Here, you grow at your pace — with smiles, support, 
            and good vibes.
          </p>
        </div>

        <div className="story-right">
          <img src="https://images.pexels.com/photos/6453399/pexels-photo-6453399.jpeg" alt="shank story" />
        </div>
      </section>


      {/* ================= VALUE PILLARS ================= */}
      <section className="ab4-pillars">
        <div className="pillar">
          <h3>Playful Energy</h3>
          <p>Fitness that feels light, fun, and refreshing — every day.</p>
        </div>

        <div className="pillar">
          <h3>Supportive Coaches</h3>
          <p>Friendly trainers who help you grow without pressure.</p>
        </div>

        <div className="pillar">
          <h3>Bright Community</h3>
          <p>A welcoming space filled with people just like you.</p>
        </div>
      </section>


      {/* ================= IMAGE STRIP ================= */}
      <section className="ab4-strip">
        <div className="strip-grid">
          <img src="https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg" alt="" />
          <img src="https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg" alt="" />
          <img src="https://images.pexels.com/photos/3823039/pexels-photo-3823039.jpeg" alt="" />
        </div>
      </section>


      {/* ================= MISSION PANEL ================= */}
      <section className="ab4-mission">
        <h2>Our Mission</h2>
        <p>
          To bring joy back into movement.  
          To create a fitness culture built on warmth, positivity, and growth.  
          To help every person step into their brightest, strongest self.
        </p>
      </section>

    </div>
  );
};

export default About;
